class ValidityState {
  invalid = $state(false)
  reason = $state('')

  setInvalid(reason: string) {
    this.invalid = true
    this.reason = reason
  }
  setValid() {
    this.invalid = false
    this.reason = ''
  }
}

const TORCHVISION_MODEL_NAME_PATTERN = /^\w+$/
const TORCHVISION_MODEL_NAME_PATTERN_NOTICE =
  'Only lowercase and uppercase letters, numbers and underscores are allowed in this field'

const HUGGINGFACE_REPO_NAME_PATTERN = /^[a-zA-Z0-9\-._]+\/[a-zA-Z0-9\-._]+$/
const HUGGINGFACE_REPO_NAME_PATTERN_NOTICE =
  'Only lowercase and uppercase letters, numbers, dashes, underscores and dots are allowed each part' +
  ' of the HuggingFace repository name and are separated by a single slash'

const REQUIRED_FIELD_NOTICE = 'This field is required'

type InputEvent = Event & { currentTarget: HTMLInputElement | null }

const getInputValidity = (event: InputEvent) => {
  if (!event.currentTarget) {
    return null
  }

  const inputElement = event.currentTarget
  return { inputElement, validityState: inputElement.validity }
}

const genericModelNameValidator =
  (patternNotice: string) => (state: ValidityState) => (event: InputEvent) => {
    const inputValidity = getInputValidity(event)
    if (!inputValidity) {
      return false
    }
    const { inputElement, validityState } = inputValidity

    if (validityState.patternMismatch) {
      inputElement.setCustomValidity(patternNotice)
      state.setInvalid(patternNotice)
    } else {
      inputElement.setCustomValidity('')
      state.setValid()
    }
  }

const regexValidator = (state: ValidityState, patternError: string) => (event: InputEvent) => {
  const inputValidity = getInputValidity(event)
  if (!inputValidity) {
    return false
  }
  const { inputElement, validityState } = inputValidity

  if (validityState.patternMismatch) {
    inputElement.setCustomValidity(patternError)
    state.setInvalid(patternError)
  } else {
    inputElement.setCustomValidity('')
    state.setValid()
  }
}

const requiredFieldValidator =
  (state: ValidityState, message = REQUIRED_FIELD_NOTICE) =>
  (event: InputEvent) => {
    const inputValidity = getInputValidity(event)
    if (!inputValidity) {
      return false
    }
    const { inputElement, validityState } = inputValidity

    if (!validityState.valueMissing) {
      inputElement.setCustomValidity('')
      state.setValid()
    } else {
      inputElement.setCustomValidity(message)
      state.setInvalid(message)
    }
  }

const torchvisionModelNameValidator = genericModelNameValidator(
  TORCHVISION_MODEL_NAME_PATTERN_NOTICE,
)

const huggingfaceRepoNameValidator = genericModelNameValidator(HUGGINGFACE_REPO_NAME_PATTERN_NOTICE)

const NOT_URL_PATTERN = '^(?![a-zA-Z][a-zA-Z0-9+.\\-]*://).*'

export {
  genericModelNameValidator,
  HUGGINGFACE_REPO_NAME_PATTERN,
  HUGGINGFACE_REPO_NAME_PATTERN_NOTICE,
  huggingfaceRepoNameValidator,
  NOT_URL_PATTERN,
  regexValidator,
  requiredFieldValidator,
  TORCHVISION_MODEL_NAME_PATTERN,
  TORCHVISION_MODEL_NAME_PATTERN_NOTICE,
  torchvisionModelNameValidator,
  ValidityState,
}
